var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentSearchMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.958,
    height: 23.746,
    viewBox: "0 0 29.958 23.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76459987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5255",
    "data-name": "Rectangle 5255",
    width: 20.423,
    height: 19.773,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98439",
    "data-name": "Group 98439",
    transform: "translate(-3384.023 -8781.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27049",
    "data-name": "Group 27049",
    transform: "translate(3401.672 8781.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-search",
    "data-name": "Icon material-search",
    d: "M13.3,12.242h-.556l-.2-.19a4.582,4.582,0,1,0-.493.493l.19.2V13.3l3.519,3.512,1.049-1.049Zm-4.223,0a3.167,3.167,0,1,1,3.167-3.167A3.163,3.163,0,0,1,9.075,12.242Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27051",
    "data-name": "Group 27051",
    transform: "translate(3384.023 8785.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26976",
    "data-name": "Group 26976",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-76459987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62355",
    "data-name": "Path 62355",
    d: "M20.275,7.319a2.7,2.7,0,0,0-2.609-1.9h-3.72L12.817,1.9a2.75,2.75,0,0,0-5.225,0L6.458,5.423H2.74a2.75,2.75,0,0,0-1.617,4.964L4.148,12.6,3,16.163a2.751,2.751,0,0,0,4.243,3.058L10.2,17.041l2.964,2.178a2.75,2.75,0,0,0,4.24-3.055L16.256,12.6l3.025-2.212a2.7,2.7,0,0,0,.99-3.068m-1.99,1.694L14.758,11.59a.848.848,0,0,0-.307.949l1.336,4.143a1.045,1.045,0,0,1-1.614,1.163l-3.467-2.551a.851.851,0,0,0-1.009,0L6.232,17.846a1.044,1.044,0,0,1-1.618-1.164l1.343-4.143a.85.85,0,0,0-.307-.949L2.124,9.012A1.044,1.044,0,0,1,2.74,7.126H7.08a.85.85,0,0,0,.81-.591L9.21,2.424a1.043,1.043,0,0,1,1.987,0l1.319,4.111a.853.853,0,0,0,.812.591h4.34a1.044,1.044,0,0,1,.616,1.886Z",
    transform: "translate(0.002 0.007)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Perm_Identity_Sharp",
    "data-name": "Icon / Perm Identity / Sharp",
    transform: "translate(3391.548 8792.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M966.687-68a1.343,1.343,0,0,0-1.344,1.344,1.343,1.343,0,0,0,1.344,1.344,1.343,1.343,0,0,0,1.344-1.344A1.343,1.343,0,0,0,966.687-68Zm0,3.023c-.9,0-2.687.45-2.687,1.344v1.008h5.374v-1.008C969.374-64.527,967.584-64.977,966.687-64.977Z",
    transform: "translate(-964 68)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentSearchMenuIcon);
export default __webpack_public_path__ + "static/media/talent-search-menu-icon.8c41b6b9a1fe8dd846d3d60ce07d96c9.svg";
export { ForwardRef as ReactComponent };